// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass } from "./Dom";
import { WebPageComponent, connectClickOutsideListener, removeClickOutsideListener } from "./WebSite.Page.Component";

export class Bookmarks extends WebPageComponent {
  constructor(element) {
    super(element);

    this.toggle = new HtmlClassSwitch(element, "Expanded");

    const query = new DomQuery(element);

    this.icon = query.getDescendant(WithClass("Icon"));
    this.contents = query.getDescendant(WithClass("Contents"));

    this.icon.addEventListener(
      'click',
      (event) => {
        this.toggleBookmarks();
      }
    );
  }

  toggleBookmarks() {
    this.toggle.toggle();

    if (this.toggle.getStatus()) {
      this.clickOutsideListener = connectClickOutsideListener(
        this.contents,
        (event) => {
          this.toggleBookmarks();
          event.stopPropagation();
        }
      );
    }
    else
      removeClickOutsideListener(this.clickOutsideListener);
  }
}

interactivityRegistration.register("Bookmarks", function (element) { return new Bookmarks(element); });
